import { Menu } from '../models/menu';
import { MANAGE_OPERATIONAL_AREAS_ROLES } from './clockload-roles';

export const menus: Menu[] = [
  {
    id: 'home',
    title: 'Início',
    type: 'item',
    displayOrder: 10,
    icon: 'home',
    path: '/',
  },
  {
    id: 'operational-areas',
    title: 'Áreas operacionais',
    type: 'group',
    displayOrder: 100,
    icon: 'timer',
    subMenu: [],
  },
  {
    id: 'administration',
    title: 'Administração',
    type: 'item',
    displayOrder: 800,
    icon: 'settings',
    path: '/operational-areas',
    permissions: MANAGE_OPERATIONAL_AREAS_ROLES,
  },
  {
    id: 'help',
    title: 'Ajuda',
    type: 'group',
    displayOrder: 900,
    icon: 'support',
    subMenu: [
      {
        id: 'about',
        title: 'Sobre',
        type: 'item',
        displayOrder: 10,
        path: '/about',
      },
      {
        id: 'tutorial',
        title: 'Tutorial',
        type: 'item',
        displayOrder: 20,
        path: '/tutorial',
      },
    ],
  },
];
